import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { 
  Delete, 
  ArrowCircleUpOutlined,
  ArrowCircleDownOutlined,
  AddCircleOutline,
  AddCircle,
  DeleteOutline
} from '@mui/icons-material';

interface SlideActionsProps {
  index: number;
  totalSlides: number;
  onMoveSlide: (index: number, direction: 'up' | 'down') => void;
  onRemoveSlide: (index: number) => void;
  onAddSlide: (position: 'above' | 'below', index: number) => void;
  lang: string;
}

function SlideActions({ 
  index, 
  totalSlides, 
  onMoveSlide, 
  onRemoveSlide,
  onAddSlide,
  lang 
}: SlideActionsProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%', mb: 1 }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Box>
          <Tooltip title={lang === 'en' ? 'Add slide above' : '在上方添加幻灯片'}>
            <IconButton 
              onClick={() => onAddSlide('above', index)}
              size="small"
              color="primary"
            >
              <AddCircleOutline />
            </IconButton>
          </Tooltip>
          <Tooltip title={lang === 'en' ? 'Add slide below' : '在下方添加幻灯片'}>
            <IconButton 
              onClick={() => onAddSlide('below', index)}
              size="small"
              color="primary"
            >
              <AddCircle />
            </IconButton>
          </Tooltip>
        </Box>
        <Box>
          <Tooltip title={lang === 'en' ? 'Move up' : '上移'}>
            <span>
              <IconButton 
                onClick={() => onMoveSlide(index, 'up')} 
                disabled={index === 0}
                size="small"
                color="primary"
              >
                <ArrowCircleUpOutlined />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={lang === 'en' ? 'Move down' : '下移'}>
            <span>
              <IconButton 
                onClick={() => onMoveSlide(index, 'down')} 
                disabled={index === totalSlides - 1}
                size="small"
                color="primary"
              >
                <ArrowCircleDownOutlined />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
        <Tooltip title={lang === 'en' ? 'Delete slide' : '删除幻灯片'}>
          <IconButton 
            onClick={() => onRemoveSlide(index)} 
            color="error"
            size="small"
          >
            <DeleteOutline />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

export default SlideActions; 